function normalizeOdds(...oddsArray){
  let probs = oddsArray.map((x) => 1/x);
  let s = probs.reduce((x, y) => x + y, 0);
  return probs.map((p) => p / s);
}

function last(array){
    return array[array.length -1]
}

function poisson(lambda, x){
  // lambda^x * e^-lambda / x!
  
  let p = 1;
  for (let xx = 1; xx<=x; xx++){
      p *= (lambda / xx);
  }

  return p * Math.pow(Math.E, -lambda);
}

function iter(pHome, pAway, f){
  for (let i = 0; i < pHome.length; i++){
      let h = pHome[i];
      for(let j = 0; j < pAway.length; j++){
          let a = pAway[j];
          f(i, h, j, a);
      }
  } 
}

function hda(pHome, pAway){
  
  let home = 0;
  let draw = 0;
  let away = 0;

  iter(pHome, pAway, (gh, hp, ga, ap) => {
      if (gh > ga) {
          home += hp * ap;
      }
      else if (gh == ga){
          draw += hp * ap; // factor to improve the draw probability
      }
      else if (gh < ga){
          away += hp * ap;
      }
  });

  return normalizeOdds( 1 / home, 1 / draw, 1 / away);

}

function ou(pHome, pAway, ouline){

  let over = 0;
  let under = 0;

  iter(pHome, pAway, (i, h, j, a) => {
          // do not include the ==
          if(i + j < ouline){
              under += h * a;
          }
          else if(i + j > ouline){
              over += h * a;
          }
  });

  return [over, under];
}

function Odds(over, under, home, draw, away, ouline){
  this.over = over;
  this.under = under;
  this.home = home;
  this.away = away;
  this.draw = draw;
  this.ouline = ouline;
}

Odds.prototype.distance = function(other) {

  let ousum = 0;
  let hdasum = 0;
  ['over', 'under'].forEach((p) => {
    let t = this[p] ;
    let o = other[p] ;
    ousum += (t - o) * (t - o) ;
});
  ['home', 'away', 'draw'].forEach((p) => {
      let t = this[p];
      let o = other[p];
      hdasum += (t - o) * (t - o);
  });
  
  return ousum+hdasum;
}

function computeGradient(xgH, xgA, odds, oldDistance){

  const EPSILON = 1e-10;

  return [
      (computeOdds(xgH + EPSILON, xgA, odds.ouline).distance(odds) - oldDistance) / EPSILON,
      (computeOdds(xgH, xgA + EPSILON, odds.ouline).distance(odds) - oldDistance) / EPSILON
  ];

}

function computeOdds(xgHome, xgAway, ouline){
  // compute the probability for each team to score a certain amount of goals
  // TODO: might make sense to memoize the two arrays
  let pHome = [ poisson(xgHome, 0) ];
  let pAway = [ poisson(xgAway, 0) ];

  let min = Math.max(xgHome, xgAway) + 1;
  let goals = 1; // first one already done
  while (goals < min || Math.max(last(pHome), last(pAway)) > 1e-5){
      pHome.push(poisson(xgHome, goals));
      pAway.push(poisson(xgAway, goals));
      goals ++;
  }

  // compute odds for hda and ou
  return new Odds(
      ...ou(pHome, pAway, ouline),
      ...hda(pHome, pAway),
      ouline
      );
}

function computeExpectedGoals(overOdds, underOdds, overUnderLine, homeOdds, drawOdds, awayOdds){

    let targetOdds = new Odds(
            ...normalizeOdds(overOdds, underOdds),
            ...normalizeOdds(homeOdds, drawOdds, awayOdds),
            overUnderLine
            );
  
    let xgHome = overUnderLine * 3 / (homeOdds * overOdds); // starting point
    let xgAway = overUnderLine * 3 / (awayOdds * overOdds);
    
    let currentOdds = computeOdds(xgHome, xgAway, overUnderLine);
    
    let oldDistance = Infinity;
    let newDistance = Infinity;
    let lambda = 0.1
    let gradient = [1, 1]
    let oldGradient = gradient
  
    while ((newDistance = currentOdds.distance(targetOdds)) > 1e-7 && lambda > 1e-10 ){
        gradient = computeGradient(xgHome, xgAway, targetOdds, newDistance);
        
        if(oldDistance < newDistance){
            lambda *= 0.5;
        }
        if (Math.abs(gradient[0]) < 1e-5 && Math.abs(gradient[1]) < 1e-5){
            gradient = oldGradient
        }
        else{
            oldGradient = gradient
        }
       
        oldDistance = newDistance;
  
        xgHome -= gradient[0] * lambda;
        xgAway -= gradient[1] * lambda;
  
        currentOdds = computeOdds(xgHome, xgAway, overUnderLine);
    }
    return {
        xgHome, 
        xgAway, 
        error: newDistance
    };
}

export {
    computeExpectedGoals,
    computeOdds
 }